<template>
  <b-row>
    <b-col cols="12" xl="12" lg="12" md="12" sm="12">
      <b-card>
        <b-card-header>
          <b-card-title class="d-flex justify-content-between align-items-center w-100">
            <div class="d-flex align-items-center">
              Review Statistics Report
              <b-dropdown id="dropdown-stats-report" text="Stats Report" variant="link" class="ml-2">
                <template #button-content>
                  <span>{{ selectedReport }}</span>
                  <i class="fa fa-chevron-down ml-2"></i>
                </template>
                <b-dropdown-item @click="selectReport('Reviewer Stats')">Reviewer Stats</b-dropdown-item>
                <b-dropdown-item @click="selectReport('Reviewee Stats')">Reviewee Stats</b-dropdown-item>
                <b-dropdown-item @click="selectReport('Standard Deviation')">Standard Deviation</b-dropdown-item>
              </b-dropdown>
            </div>
            <div>
            <div class="d-flex align-items-end">
            <treeselect
              v-model="selectedDepartments"
              value-consists-of="LEAF_PRIORITY"
              :limit="3"
              :multiple="true"
              :options="departmentOptions"
            />
            </div>
            </div>
          </b-card-title>
        </b-card-header>

        <b-card-body>
          <!-- Reviewer Stats Component -->
          <ObserverStats 
            v-if="selectedReport === 'Reviewer Stats'" 
            :key="'observer-' + componentKey"
            :StatTrigger="currentStatTabComponent" 
            :selectedSites="siteIds"
            class="animate__animated animate__fadeIn" 
          />

          <!-- Reviewee Stats Component -->
          <TeacherStats 
            v-if="selectedReport === 'Reviewee Stats'" 
            :key="'teacher-' + componentKey"
            :StatTrigger="currentStatTabComponent" 
            :selectedSites="siteIds"
            class="animate__animated animate__fadeIn" 
          />

          <!-- Standard Deviation Component -->
          <ObserverStandardDeviation 
            v-if="selectedReport === 'Standard Deviation'" 
            :key="'deviation-' + componentKey"
            :StatTrigger="currentStatTabComponent" 
            :selectedSites="siteIds"
            class="animate__animated animate__fadeIn" 
          />
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BCol, BRow, BCard, BAlert, BLink, VBModal } from 'bootstrap-vue';
import { ref, onUnmounted } from '@vue/composition-api';
import 'animate.css';

import ObserverStats from './ObserverStats.vue';
import TeacherStats from './TeacherStats.vue';
import ObserverStandardDeviation from './GrowthObserverSDeviation.vue';
import store from '@/store';
import reportStoreModule from '../reportStoreModule';
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import axiosIns from '@/libs/axios';
export default {
  components: {
    ObserverStats,
    TeacherStats,
    ObserverStandardDeviation,
    BRow,
    BCol,
    Treeselect,
  },
  props: ['trigger'],

  setup() {
    const REPORT_APP_STORE_MODULE_NAME = 'report';
    // Register module
    if (!store.hasModule(REPORT_APP_STORE_MODULE_NAME)) store.registerModule(REPORT_APP_STORE_MODULE_NAME, reportStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(REPORT_APP_STORE_MODULE_NAME)) store.unregisterModule(REPORT_APP_STORE_MODULE_NAME);
    });
  },

  data() {
    return {
      selectedReport: 'Reviewer Stats',
      currentStatTabComponent: 'ObserverStats',
      componentKey: 0,
            departmentOptions: [],
      selectedDepartments: [],
    };
  },
  mounted() {
    // Set initial component based on selected report
    this.updateCurrentComponent();
    this.fetchReportOptions();
  },
  watch: {
    trigger: {
      handler: function(val, before) {
        if (val === 'ReviewStats') {
          this.selectedReport = 'Reviewer Stats';
          this.updateCurrentComponent();
          // Force component re-creation
          this.componentKey += 1;
        }
      },
      immediate: false,
    },
  },
  methods: {
    selectReport(report) {
      this.selectedReport = report;
      this.updateCurrentComponent();
      // Force component re-creation by updating key
      this.componentKey += 1;
      console.log('Selected report:', report);
    },

    updateCurrentComponent() {
      // Map selected report to component trigger
      switch (this.selectedReport) {
        case 'Reviewer Stats':
          this.currentStatTabComponent = 'ObserverStats';
          break;
        case 'Reviewee Stats':
          this.currentStatTabComponent = 'TeacherStats';
          break;
        case 'Standard Deviation':
          this.currentStatTabComponent = 'ObserverStandardDeviation';
          break;
        default:
          this.currentStatTabComponent = 'ObserverStats';
      }
    },
    fetchReportOptions(){
      axiosIns.post('reportOptions', {})
        .then(res => {
          if(res.data && res.data.options){
            this.departmentOptions = res.data.options;
          }
        })
        .catch(err => { console.error('reportOptions error', err); });
    },
       

  },
  computed: {
    siteIds(){
      // Filter out department ids ending with '-d'
      if(!this.selectedDepartments || this.selectedDepartments.length === 0) return [];
      return this.selectedDepartments.filter(id => typeof id === 'string' ? !id.endsWith('-d') : true);
    }
  },
};
</script>

<style scoped>
.dropdown-toggle {
  color: #495057 !important;
  text-decoration: none !important;
}

.dropdown-toggle:hover {
  color: #007bff !important;
}

.dropdown-menu {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

.card-title {
  margin-bottom: 0;
  font-weight: 600;
  color: #495057;
}
</style>
